// extracted by mini-css-extract-plugin
module.exports = {"createEvent":"Events-tab_createEvent_zA3Ti","resetButtonContainer":"Events-tab_resetButtonContainer_1mrla"};